import { ContentCard, PageLayout, WithGlowBackground } from 'shared/components';
import { useIsMobile } from 'shared/hooks';

import SignInToContinue from './SignInToContinue';

export default function SignInToContinuePage({ variant = 'continue' }: { variant?: 'continue' | 'firstTime' }) {
    const isMobile = useIsMobile();

    return (
        <WithGlowBackground>
            <PageLayout verticallyCenter={ isMobile }>
                <PageLayout.Content size="md">
                    <ContentCard>
                        <SignInToContinue variant={ variant } />
                    </ContentCard>
                </PageLayout.Content>
            </PageLayout>
        </WithGlowBackground>
    );
}
